module.exports = __webpack_public_path__ + "img/book.6c79b0de.svg";